import { useStaticQuery, graphql } from 'gatsby';
/**
 * NOTE:
 * - these are the flags as they were available at last build time, for an anonymous user, via the ff-source-launchdarkly plugin
 * - we've set up webhooks to rebuild the site when a flag is changed
 * - this hook cannot be used for bucketing, partial rollouts, user-level targeting, etc
 * - results from LD can be overridden by adding a key beginning with "LD_OVERRIDE_" to your .env file
 * - flags need to also be defined/typed in the ff-source-launchdarkly-plugin, in "createSchemaCustomization"
 * - TODO: implement the client side plugin https://github.com/launchdarkly/gatsby-plugin-launchdarkly/
 */
const useLaunchDarklyFlags = () => {
  const { ldFlags } = useStaticQuery(graphql`
    query {
      ldFlags {
        enableSegment
        testFlag
      }
    }
  `);

  return ldFlags;
};

export default useLaunchDarklyFlags;
